import {Provider} from "@angular/core";
import {MODULE_VERSIONS} from "@fedelta-pos/data-client";
import {AppModuleConstants} from "../app.module.constants";

export const WebOrderingAppVersion: Provider = {
    provide: MODULE_VERSIONS,
    useValue: {
        "module": "web-order-app",
        "version": AppModuleConstants.VERSION
    },
    multi: true
};



// WEBPACK FOOTER //
// ./src/app/config-support/version.ts